import {
  fetchModulesForCourse,
  isModularCourse,
  type CourseModuleOption,
} from 'store/courses-lessons/helpers';

export {
  fetchModulesForCourse,
  isModularCourse,
  type CourseModuleOption,
};

export type CourseLessonOption = {
  id: string;
  title: string;
  displayTitle: string;
  moduleId?: string;
};

export type CourseLessonModuleGroup = {
  id: string;
  title: string;
  lessons: CourseLessonOption[];
};

export const UNASSIGNED_MODULE_GROUP_ID = 'unassigned';

export const buildCourseLessonOptions = (lessons: any[]): CourseLessonOption[] =>
  lessons.map((lesson) => {
    const lessonId = lesson._id ?? lesson.id;
    const moduleId = lesson.moduleId?.toString?.() ?? lesson.moduleId;
    const title = lesson.title || '';

    return {
      id: lessonId,
      title,
      displayTitle: title,
      moduleId,
    };
  });

export const groupCourseLessonsByModule = (
  lessons: CourseLessonOption[],
  modules: CourseModuleOption[],
  unassignedModuleTitle: string,
): CourseLessonModuleGroup[] => {
  const moduleIds = new Set(modules.map((courseModule) => courseModule.id));
  const lessonsByModuleId = new Map<string, CourseLessonOption[]>();
  const unassignedLessons: CourseLessonOption[] = [];

  for (const lesson of lessons) {
    const lessonOption: CourseLessonOption = {
      ...lesson,
      displayTitle: lesson.title,
    };

    if (lesson.moduleId && moduleIds.has(lesson.moduleId)) {
      const moduleLessons = lessonsByModuleId.get(lesson.moduleId) ?? [];

      moduleLessons.push(lessonOption);
      lessonsByModuleId.set(lesson.moduleId, moduleLessons);
    } else {
      unassignedLessons.push(lessonOption);
    }
  }

  const groups: CourseLessonModuleGroup[] = [];

  for (const courseModule of modules) {
    const moduleLessons = lessonsByModuleId.get(courseModule.id);

    if (moduleLessons?.length) {
      groups.push({
        id: courseModule.id,
        title: courseModule.title,
        lessons: moduleLessons,
      });
    }
  }

  if (unassignedLessons.length) {
    groups.push({
      id: UNASSIGNED_MODULE_GROUP_ID,
      title: unassignedModuleTitle,
      lessons: unassignedLessons,
    });
  }

  return groups;
};
